var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 147,
    viewBox: "0 0 220 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31962_46744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.1823 18.2891V34.8397M134.317 18.2891V34.8397M65.3568 57.4029H159.144M161.902 54.1486V101.042C161.902 117.593 153.626 128.626 134.317 128.626H90.1823C70.8734 128.626 62.598 117.593 62.598 101.042V54.1486C62.598 37.598 70.8734 26.5642 90.1823 26.5642H134.317C153.626 26.5642 161.902 37.598 161.902 54.1486Z",
    stroke: "#C3CDDF",
    strokeOpacity: 0.61,
    strokeWidth: 5.86667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.633 82.8374H132.683M132.633 99.388H132.683M112.225 82.8374H112.275M112.225 99.388H112.275M91.8065 82.8374H91.8559M91.8065 99.388H91.8559",
    stroke: "#C3CDDF",
    strokeOpacity: 0.61,
    strokeWidth: 11.7333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4262 35.527L44.4684 40.7759C41.2517 41.9828 38.6225 45.8 38.6225 49.2523V70.1068C38.6225 73.4191 40.8044 77.7694 43.4615 79.7624L55.4892 88.7721C59.4333 91.7475 65.9225 91.7475 69.8664 88.7721L81.8941 79.7624C84.5514 77.7694 86.7331 73.4191 86.7331 70.1068V49.2523C86.7331 45.8 84.1038 41.9828 80.8872 40.7759L66.9294 35.527C64.5519 34.657 60.7479 34.657 58.4262 35.527Z",
    fill: "#572148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6414 73.7073C55.8505 73.7073 50.3456 68.2022 50.3456 61.4115C50.3456 54.6206 55.8505 49.1157 62.6414 49.1157C69.4321 49.1157 74.9372 54.6206 74.9372 61.4115C74.9372 68.2022 69.4321 73.7073 62.6414 73.7073Z",
    stroke: "white",
    strokeWidth: 2.68889,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8734 57.5688V60.4276C61.8734 61.5034 62.4268 62.5179 63.3797 63.0713L65.7158 64.4852",
    stroke: "white",
    strokeWidth: 2.68889,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4216 29.5923C58.3229 31.5275 63.5012 29.0391 63.5012 29.0391C63.5012 29.0391 62.3504 23.4142 58.4468 21.4816C54.5455 19.5463 49.3694 22.0318 49.3694 22.0318C49.3694 22.0318 50.5202 27.657 54.4216 29.5923Z",
    fill: "url(#paint0_linear_31962_46744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3044 110.083C52.859 110.083 54.1192 111.344 54.1192 112.898C54.1192 114.453 52.859 115.713 51.3044 115.713C49.7498 115.713 48.4896 114.453 48.4896 112.898C48.4896 111.344 49.7498 110.083 51.3044 110.083Z",
    fill: "#572148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.375 18.2007C165.767 18.2007 167.706 20.1397 167.706 22.5317C167.706 24.9237 165.767 26.8628 163.375 26.8628C160.983 26.8628 159.044 24.9237 159.044 22.5317C159.044 20.1397 160.983 18.2007 163.375 18.2007Z",
    fill: "#572148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.615 60.9245C177.168 60.9245 178.428 59.6648 178.428 58.1109C178.428 56.557 177.168 55.2974 175.615 55.2974C174.061 55.2974 172.801 56.557 172.801 58.1109C172.801 59.6648 174.061 60.9245 175.615 60.9245Z",
    fill: "#572148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.516 89.5382C179.712 89.5382 181.492 87.7578 181.492 85.5616C181.492 83.3654 179.712 81.585 177.516 81.585C175.319 81.585 173.539 83.3654 173.539 85.5616C173.539 87.7578 175.319 89.5382 177.516 89.5382Z",
    fill: "#C3CDDF",
    fillOpacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.103 124.588C172.006 124.588 173.548 123.046 173.548 121.144C173.548 119.242 172.006 117.7 170.103 117.7C168.201 117.7 166.659 119.242 166.659 121.144C166.659 123.046 168.201 124.588 170.103 124.588Z",
    fill: "#C3CDDF",
    fillOpacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3667 96.5712C49.5201 96.5712 50.455 95.8012 50.455 94.8515C50.455 93.9018 49.5201 93.1318 48.3667 93.1318C47.2134 93.1318 46.2784 93.9018 46.2784 94.8515C46.2784 95.8012 47.2134 96.5712 48.3667 96.5712Z",
    fill: "#C3CDDF",
    fillOpacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8242 130.966C57.8242 132.323 58.924 133.423 60.2808 133.423C61.6376 133.423 62.7375 132.323 62.7375 130.966C62.7375 129.609 61.6376 128.509 60.2808 128.509C58.924 128.509 57.8242 129.609 57.8242 130.966Z",
    fill: "#C3CDDF",
    fillOpacity: 0.61
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31962_46744",
    x1: 69.4033,
    y1: 35.6288,
    x2: 37.2247,
    y2: 10.1756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31962_46744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 146.667,
    fill: "white",
    transform: "translate(0 0.166504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEvent);
export default __webpack_public_path__ + "static/media/CreateEvent.2a233dd0b3196e9c73235e3257961a41.svg";
export { ForwardRef as ReactComponent };